module.exports = function () {
  return "<div class=\"game-scoreboard\" id=\"game-scoreboard\"></div>";
};